import { createReducer } from 'redux-act';
import actions from "../actions/attendanceDashboardActions";

const initialState = {
  checkInCheckOutPending: false,
  checkInCheckOutRes: null,
  checkInCheckOutError: null,

  getCheckInCheckOutPending: false,
  getCheckInCheckOutRes: null,
  getCheckInCheckOutError: null,

  getAttendanceSummaryPending: false,
  getAttendanceSummaryRes: null,
  getAttendanceSummaryError: null,

  getMonthlyAttendancePending: false,
  getMonthlyAttendanceRes: null,
  getMonthlyAttendanceError: null,

  getAttendanceDashBoardPending: false,
  getAttendanceDashBoardRes: null,
  getAttendanceDashBoardError: null,

  getCorrectionNotificationPending: false,
  getCorrectionNotificationRes: null,
  getCorrectionNotificationError: null,

  
  attendanceLockPending: false,
  attendanceLockRes: null,
  attendanceLockError: null,

  getAttendanceLockPending: false,
  getAttendanceLockRes: null,
  getAttendanceLockError: null,

  updateAttendanceLockPending: false,
  updateAttendanceLockRes: null,
  updateAttendanceLockError: null,

};

// Check In Check Ourt REDUCERS
const handlecheckInCheckOutRequest = state => {
  return {
    ...state,
    ...{
      checkInCheckOutPending: true,
      checkInCheckOutRes: null,
      checkInCheckOutError: null,
    },
  };
};
const handlecheckInCheckOutSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      checkInCheckOutPending: false,
      checkInCheckOutRes: payload,
      checkInCheckOutError: null,
    },
  };
};
const handlecheckInCheckOutError = (state, payload) => ({
  ...state,
  ...{
    checkInCheckOutPending: false,
    checkInCheckOutRes: null,
    checkInCheckOutError: payload,
  },
});

//Get Check In Check Ourt REDUCERS
const handleGetCheckInCheckOutRequest = state => {
  return {
    ...state,
    ...{
      getCheckInCheckOutPending: true,
      getCheckInCheckOutRes: null,
      getCheckInCheckOutError: null,
    },
  };
};
const handleGetCheckInCheckOutSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getCheckInCheckOutPending: false,
      getCheckInCheckOutRes: payload,
      getCheckInCheckOutError: null,
    },
  };
};
const handleGetCheckInCheckOutError = (state, payload) => ({
  ...state,
  ...{
    getCheckInCheckOutPending: false,
    getCheckInCheckOutRes: null,
    getCheckInCheckOutError: payload,
  },
});

// Get Attendance Summary
const handleGetAttendanceSummaryRequest = state => {
  return {
    ...state,
    ...{
      getAttendanceSummaryPending: true,
      getAttendanceSummaryRes: null,
      getAttendanceSummaryError: null,
    },
  };
};
const handleGetAttendanceSummarySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getAttendanceSummaryPending: false,
      getAttendanceSummaryRes: payload,
      getAttendanceSummaryError: null,
    },
  };
};
const handleGetAttendanceSummaryError = (state, payload) => ({
  ...state,
  ...{
    getAttendanceSummaryPending: false,
    getAttendanceSummaryRes: null,
    getAttendanceSummaryError: payload,
  },
});

//Get Attendance REDUCERS
const handleGetMonthlyAttendanceRequest = state => {
  return {
    ...state,
    ...{
      getMonthlyAttendancePending: true,
  getMonthlyAttendanceRes: null,
  getMonthlyAttendanceError: null,
    },
  };
};
const handleGetMonthlyAttendanceSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getMonthlyAttendancePending: false,
      getMonthlyAttendanceRes: payload,
      getMonthlyAttendanceError: null,
    },
  };
};
const handleGetMonthlyAttendanceError = (state, payload) => ({
  ...state,
  ...{
    getMonthlyAttendancePending: false,
      getMonthlyAttendanceRes: null,
      getMonthlyAttendanceError: payload,
  },
});

//gat Attendance DashBoard
const handleGetAttendanceDashBoardRequest = state => {
  return {
    ...state,
    ...{
      getAttendanceDashBoardPending: true,
      getAttendanceDashBoardRes: null,
      getAttendanceDashBoardError: null,
    },
  };
};
const handleGetAttendanceDashBoardSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getAttendanceDashBoardPending: false,
      getAttendanceDashBoardRes: payload,
      getAttendanceDashBoardError: null,
    },
  };
};
const handleGetAttendanceDashBoardError = (state, payload) => ({
  ...state,
  ...{
    getAttendanceDashBoardPending: false,
    getAttendanceDashBoardRes: null,
    getAttendanceDashBoardError: payload,
  },
});

/* Get Correction Notification */
const handleGetCorrectionNotificationRequest = state => {
  return {
    ...state,
    ...{
      getCorrectionNotificationPending: true,
      getCorrectionNotificationRes: null,
      getCorrectionNotificationError: null,
    },
  };
};
const handleGetCorrectionNotificationSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getCorrectionNotificationPending: false,
      getCorrectionNotificationRes: payload,
      getCorrectionNotificationError: null,
    },
  };
};
const handleGetCorrectionNotificationError = (state, payload) => ({
  ...state,
  ...{
    getCorrectionNotificationPending: false,
    getCorrectionNotificationRes: null,
    getCorrectionNotificationError: payload,
  },
});

/* Get Correction Notification */
const handleAttendanceLockRequest = state => {
  return {
    ...state,
    ...{
      attendanceLockPending: true,
      attendanceLockRes: null,
      attendanceLockError: null,
    },
  };
};
const handleAttendanceLockSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      attendanceLockPending: false,
      attendanceLockRes: payload,
      attendanceLockError: null,
    },
  };
};
const handleAttendanceLockError = (state, payload) => ({
  ...state,
  ...{
    attendanceLockPending: false,
    attendanceLockRes: null,
    attendanceLockError: payload,
  },
});

/* Get Correction Notification */
const handleGetAttendanceLockRequest = state => {
  return {
    ...state,
    ...{
      getAttendanceLockPending: true,
      getAttendanceLockRes: null,
      getAttendanceLockError: null,
    },
  };
};
const handleGetAttendanceLockSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getAttendanceLockPending: false,
      getAttendanceLockRes: payload,
      getAttendanceLockError: null,
    },
  };
};
const handleGetAttendanceLockError = (state, payload) => ({
  ...state,
  ...{
    getAttendanceLockPending: false,
    getAttendanceLockRes: null,
    getAttendanceLockError: payload,
  },
});

/* Get Correction Notification */
const handleUpdateAttendanceLockRequest = state => {
  return {
    ...state,
    ...{
      updateAttendanceLockPending: true,
      updateAttendanceLockRes: null,
      updateAttendanceLockError: null,
    },
  };
};
const handleUpdateAttendanceLockSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      updateAttendanceLockPending: false,
      updateAttendanceLockRes: payload,
      updateAttendanceLockError: null,
    },
  };
};
const handleUpdateAttendanceLockError = (state, payload) => ({
  ...state,
  ...{
    updateAttendanceLockPending: false,
    updateAttendanceLockRes: null,
    updateAttendanceLockError: payload,
  },
});


// handle clear login 
const handleClearAttendanceDashboardStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_CHECK_IN_CHECK_OUT_STORE':
      return {
        ...state,
        ...{
          checkInCheckOutPending: false,
          checkInCheckOutRes: null,
          checkInCheckOutError: null,

        },
      };
      case 'HANDLE_CLEAR_ATTENDANCE_LOCK_STORE':
        return {
          ...state,
          ...{
            attendanceLockPending: false,
            attendanceLockRes: null,
            attendanceLockError: null,
  
          },
        };
        case 'HANDLE_CLEAR_UPDATE_ATTENDANCE_LOCK_STORE':
          return {
            ...state,
            ...{
              updateAttendanceLockPending: false,
              updateAttendanceLockRes: null,
              updateAttendanceLockError: null,
    
            },
          };
    default:
      return state;
  }
};

export default createReducer(
  {
    [actions.checkInCheckOutRequest]: handlecheckInCheckOutRequest,
    [actions.checkInCheckOutSuccess]: handlecheckInCheckOutSuccess,
    [actions.checkInCheckOutError]: handlecheckInCheckOutError,

    [actions.getCheckInCheckOutRequest]: handleGetCheckInCheckOutRequest,
    [actions.getCheckInCheckOutSuccess]: handleGetCheckInCheckOutSuccess,
    [actions.getCheckInCheckOutError]: handleGetCheckInCheckOutError,

    [actions.getAttendanceSummaryRequest]: handleGetAttendanceSummaryRequest,
    [actions.getAttendanceSummarySuccess]: handleGetAttendanceSummarySuccess,
    [actions.getAttendanceSummaryError]: handleGetAttendanceSummaryError,

    [actions.getMonthlyAttendanceRequest]: handleGetMonthlyAttendanceRequest,
    [actions.getMonthlyAttendanceSuccess]: handleGetMonthlyAttendanceSuccess,
    [actions.getMonthlyAttendanceError]: handleGetMonthlyAttendanceError,

    [actions.getAttendanceDashBoardRequest]: handleGetAttendanceDashBoardRequest,
    [actions.getAttendanceDashBoardSuccess]: handleGetAttendanceDashBoardSuccess,
    [actions.getAttendanceDashBoardError]: handleGetAttendanceDashBoardError,

    [actions.getCorrectionNotificationRequest]: handleGetCorrectionNotificationRequest,
    [actions.getCorrectionNotificationSuccess]: handleGetCorrectionNotificationSuccess,
    [actions.getCorrectionNotificationError]: handleGetCorrectionNotificationError,
    
    [actions.attendanceLockRequest]: handleAttendanceLockRequest,
    [actions.attendanceLockSuccess]: handleAttendanceLockSuccess,
    [actions.attendanceLockError]: handleAttendanceLockError,

    [actions.getAttendanceLockRequest]: handleGetAttendanceLockRequest,
    [actions.getAttendanceLockSuccess]: handleGetAttendanceLockSuccess,
    [actions.getAttendanceLockError]: handleGetAttendanceLockError,
    
    [actions.updateAttendanceLockRequest]: handleUpdateAttendanceLockRequest,
    [actions.updateAttendanceLockSuccess]: handleUpdateAttendanceLockSuccess,
    [actions.updateAttendanceLockError]: handleUpdateAttendanceLockError,


    // clear Attendance Dashboard store
    [actions.handleClearAttendanceDashboardStore]: handleClearAttendanceDashboardStore,
  },
  initialState,
);